import { dayjsInit } from '@ow/utils'

const transformer = function (origin, defs) {
  const { showTime, format } = defs

  let text
  try {
    if (format) {
      text = dayjsInit(origin).format(format)
    } else {
      text = dayjsInit(origin).format(
        showTime ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD'
      )
    }
  } catch (e) {
    text = 'error'
  }
  return {
    render: 'text',
    value: origin && {
      text,
    },
    origin,
    defs,
  }
}

export default transformer
